import React from "react"
import { concatStrings } from "../utilities"

const DfbCheckbox = React.forwardRef((props, ref) => {
  const disabled = props.disabled ? { disabled: true } : {}
  const checked = props.checked ? { checked: true } : {}
  const required = props.required ? { required: true } : {}
  const requiredClass = props.requiredClass ? "is-required" : ""
  const errorClass = props.error ? "is-invalid" : ""

  return (
    <div
      className={concatStrings(
        "dfb-Checkbox",
        errorClass,
        requiredClass,
        props.add_class
      )}
    >
      <label className="dfb-Checkbox-field">
        <input
          ref={ref}
          className={concatStrings("dfb-Checkbox-input", errorClass)}
          type="checkbox"
          value="true"
          name={props.name}
          onChange={props.onChange}
          onBlur={props.onBlur}
          {...required}
          {...checked}
          {...disabled}
        />
        <span className="dfb-Checkbox-box" aria-hidden="true"></span>
        {props.text && props.text.length > 0 && (
          <span
            className="dfb-Checkbox-label"
            dangerouslySetInnerHTML={{ __html: props.text }}
          ></span>
        )}
      </label>
    </div>
  )
})
export default DfbCheckbox
